import { map, catchError } from 'rxjs/operators';
import axios from 'axios-observable';
import { ajax } from '../../../../common/http/authAjax';
import { Case } from '../../../domain/case';
import { handleUnauthorized } from '../../../../hooks/auth/auth.hook';

function mapCase(data) {
  return {
    ...data,
    data: Case({...data.data}),
  };
}

function mapCaseList(cases) {
  return {
    ...cases.data,
    data: cases.data.data.map((el) => Case({...el})),
  };
}

function mapListOptions(options) {
  return {
    ...options,
    data: options.data.map((option) => ({
      label: option,
      value: option,
    })),
  };
}

function isSelected(item) {
  return item.selected;
}

function CaseListGatewayRest() {
  return {
    retrieveCaseList(queryString) {
      return axios.get(`${process.env.REACT_APP_API_URL}/api/record/getList${queryString === undefined ? '' : queryString}`, {
        headers: {'x-access-token': localStorage.getItem('admin-token')},
      }).pipe(
        map((cases) => mapCaseList(cases)),
        catchError(handleUnauthorized),
      );
    },
    getAutomaticsLogs(claimId) {
      return axios.get(`${process.env.REACT_APP_API_URL}/api/automatic/logs?claimId=${claimId}`, {
        headers: {'x-access-token': localStorage.getItem('admin-token')},
      }).pipe(
        catchError(handleUnauthorized),
      );
    },
    retrieveOperatingAirlines(params) {
      console.log('params', params);

      const queryParams = new URLSearchParams();
      Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value);
        }
      });

      const baseUrl = `${process.env.REACT_APP_API_URL}/api/record/getAirlines`;
      const url = queryParams.toString() ? `${baseUrl}?${queryParams.toString()}` : baseUrl;

      return axios.get(url, {
        headers: { 'x-access-token': localStorage.getItem('admin-token') },
      }).pipe(
        map((airlines) => mapListOptions(airlines.data)),
        catchError(handleUnauthorized),
      );
    },
    retrieveJurisdictions() {
      return axios.get(`${process.env.REACT_APP_API_URL}/api/record/getJurisdiction`, {
        headers: {'x-access-token': localStorage.getItem('admin-token')},
      }).pipe(
        map((jurisdictions) => mapListOptions(jurisdictions.data)),
        catchError(handleUnauthorized),
      );
    },
    updateMultipleStatus(status, list) {
      const recordsId = list.filter(isSelected).map((item) => item._id);
      return ajax({
        method: 'post',
        url: `${process.env.REACT_APP_API_URL}/api/claim/update/status`,
        body: {claimIds: recordsId, status},
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': localStorage.getItem('admin-token'),
        },
      }).pipe(
        catchError(handleUnauthorized),
      );
    },
    updateStatusClaim(status, id) {
      return ajax({
        method: 'post',
        url: `${process.env.REACT_APP_API_URL}/api/claim/update/status`,
        body: {claimIds: [id], status},
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': localStorage.getItem('admin-token'),
        },
      }).pipe(
        catchError(handleUnauthorized),
      );
    },
    retrieveCaseById(queryString) {
      return axios.get(`${process.env.REACT_APP_API_URL}/api/record/get${queryString === undefined ? '' : queryString}`, {
        headers: {'x-access-token': localStorage.getItem('admin-token')},
      }).pipe(
        map((cases) => mapCase(cases.data)),
        catchError(handleUnauthorized),
      );
    },
    syncWithAlgolia({claimId}) {
      return axios.get(`${process.env.REACT_APP_API_URL}/api/algolia/sync?claimId=${claimId}`, {
        headers: {'x-access-token': localStorage.getItem('admin-token')},
      }).pipe(
        catchError(handleUnauthorized),
      );
    },
    updateSinglePassenger(passengerId, data) {
      const freshSend = {
        customerId: passengerId,
        customer: {
          ...data,
        },
      };

      return ajax.post(`${process.env.REACT_APP_API_URL}/api/customer/updateSingle`, JSON.stringify({...freshSend}), {
        'x-access-token': localStorage.getItem('admin-token'),
        'Content-Type': 'application/json',
      }).pipe(
        catchError(handleUnauthorized),
      );
    },
    updateSingleCase(caseId, data) {
      const fieldToUpdate = {
        recordId: caseId,
        record: {
          ...data,
        },
      };
      return ajax.post(`${process.env.REACT_APP_API_URL}/api/record/update`, JSON.stringify({
        ...fieldToUpdate,
      }), {
        'x-access-token': localStorage.getItem('admin-token'),
        'Content-Type': 'application/json',
      }).pipe(
        catchError(handleUnauthorized),
      );
    },
    generateDocuments(folder, type) {
      if (type === 'merge') {
        const objForPdf = {
          name: `Pièces-justificatives-dossier-${folder.fullNameMainPassenger().replace(/ /g, '-')}`,
          key: folder._id,
        };
        return ajax.post(`${process.env.REACT_APP_API_URL}/api/generate/${type}`, {
          ...objForPdf,
        }, {
          'x-access-token': localStorage.getItem('admin-token'),
          'Content-Type': 'application/json',
        }).pipe(
          catchError(handleUnauthorized),
        );
      }
      return ajax.post(`${process.env.REACT_APP_API_URL}/api/generate/${type}`, {
        id: folder._id,
      }, {
        'x-access-token': localStorage.getItem('admin-token'),
        'Content-Type': 'application/json',
      }).pipe(
        catchError(handleUnauthorized),
      );
    },
    removeDocuments(folder) {
      const documentsId = folder.documents.filter((e) => e.selected).map((id) => id._id);
      return ajax.post(`${process.env.REACT_APP_API_URL}/api/document/delete`, {
        documentsId,
      }, {
        'x-access-token': localStorage.getItem('admin-token'),
        'Content-Type': 'application/json',
      }).pipe(
        catchError(handleUnauthorized),
      );
    },
    addComment(folder, message) {
      const log = {
        custom: {
          message,
        },
      };
      return ajax.post(`${process.env.REACT_APP_API_URL}/api/logger/add`, {
        recordId: folder._id,
        action: {...log},
      }, {
        'x-access-token': localStorage.getItem('admin-token'),
        'Content-Type': 'application/json',
      }).pipe(
        catchError(handleUnauthorized),
      );
    },
    retrieveHearingDates(id) {
      return ajax.getJSON(`${process.env.REACT_APP_API_URL}/api/convocation/passenger?id=${id}`, {
        'x-access-token': localStorage.getItem('admin-token'),
      }).pipe(
        catchError(handleUnauthorized),
      );
    },
    retrieveAirhelpCompensation(claimIds) {
      return ajax.post(`${process.env.REACT_APP_API_URL}/api/record/finalCompensation`, JSON.stringify({claimIds}), {
        'x-access-token': localStorage.getItem('admin-token'),
        'Content-Type': 'application/json',
      }).pipe(
        catchError(handleUnauthorized),
      );
    }
  };
}

export {
  CaseListGatewayRest,
  axios,
};
